import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { CheckIcon, XIcon } from '@reverbdotcom/cadence/icons/react';
import { RCTextWithIcon } from '@reverbdotcom/cadence/components';
import URLHelpers from './shared/url_helpers';

export function ProductReviewGuidelines() {
  return (
    <div>
      <h4 className="size-110 weight-bold">
        {I18n.t('discovery.productReviews.guidelines.tips')}
        <small className="ml-space">
          (
          <CoreLink
            to={URLHelpers.productReviewGuidelinesPath}
            target="_blank"
            rel="nofollow noopener noreferrer"
          >
            {I18n.t('discovery.productReviews.guidelines.seeAll')}
          </CoreLink>
          )
        </small>
      </h4>
      <div className="size-80 d-flex mtb-2">
        <RCTextWithIcon
          placement="left"
          svgComponent={CheckIcon}
        >
          {I18n.t('discovery.productReviews.guidelines.do')}
        </RCTextWithIcon>
      </div>
      <div className="size-80 d-flex">
        <RCTextWithIcon
          placement="left"
          svgComponent={XIcon}
        >
          {I18n.t('discovery.productReviews.guidelines.dont')}
        </RCTextWithIcon>
      </div>
    </div>
  );
}
